import { render } from "./baseCalendar.vue?vue&type=template&id=af408264"
import script from "./baseCalendar.vue?vue&type=script&lang=js"
export * from "./baseCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__